
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { userActions } from '../_actions'

function SidebarComponent({ isExpand, updateToolTip, logoutSession }) {
  const [showTooltip, setShowTooltip] = useState(false)
  const dashboard = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Dashboard</Tooltip>)
  const searchCompanies = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Search Companies</Tooltip>)
  const manageSectors = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Sectors</Tooltip>)
  const manageIndustries = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Industries</Tooltip>)
  const manageCompanies = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Companies </Tooltip>)
  const copyPaste = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Copy & Paste Data</Tooltip>)
  const manageExchanges = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Exchanges</Tooltip>)
  const mapKeys = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Map Keys</Tooltip>)
  const settings = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Settings</Tooltip>)
  const manageUsers = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Users </Tooltip>)
  const bulkUpload = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Bulk Upload - Data</Tooltip>)
  const manageContent = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Manage Content </Tooltip>)
  const library = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Library</Tooltip>)
  const preview = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Preview Companies</Tooltip>)
  const medievalMapDemo = props => (<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before' : 'tooltip-menu-none'} {...props}>Medieval Map Demo</Tooltip>)

  //const toolTip =(props)=>(<Tooltip className={showTooltip ? 'tooltip-menu tooltip-menu:before':'tooltip-menu-none'} {...props}>Bulk Copy</Tooltip>)

  useEffect(() => {
    ToggleMenuSetion(isExpand)
  }, [isExpand])
  const history = useHistory()
  const menuToggle = useRef()

  const location = useLocation()
  React.useEffect(() => {
  }, [location])

  const navigatePage = (pageName) => {
    if (userActions.getCurrentToken()) {
      const dashboardContent = '/dashboard'
      switch (pageName) {
        case 'bulkcopy':
          updateToolTip(true)
          history.push(dashboardContent + '/bulk-copy')
          break
        case 'dashboard':
          updateToolTip(true)
          history.push(dashboardContent + '/dashboard')
          break
        case 'companies':
          updateToolTip(true)
          history.push(dashboardContent + '/company-tree')
          break
        case 'industry':
          updateToolTip(true)
          history.push(dashboardContent + '/industry-list')
          break
        case 'company':
          updateToolTip(false)
          history.push(dashboardContent + '/company-list')
          break
        case 'import':
          updateToolTip(false)
          history.push(dashboardContent + '/import-data')
          break
        case 'sector':
          updateToolTip(true)
          history.push(dashboardContent + '/sector-list')
          break
        case 'exchange':
          updateToolTip(true)
          history.push(dashboardContent + '/exchange-list')
          break
        case 'content':
          updateToolTip(true)
          history.push(dashboardContent + '/content-list')
          break
        case 'mapkey':
          updateToolTip(true)
          history.push(dashboardContent + '/map-keys')
          break
        case 'settings':
          updateToolTip(true)
          history.push(dashboardContent + '/settings')
          break
        case 'user':
          updateToolTip(true)
          history.push(dashboardContent + '/user-list')
          break
        case 'library':
          updateToolTip(true)
          history.push(dashboardContent + '/library')
          break
        case 'preview':
          updateToolTip(false)
          history.push(dashboardContent + '/preview')
          break
        case 'bulk_upload':
          updateToolTip(true)
          history.push(dashboardContent + '/bulk-upload')
          break
        case 'medieval_map_demo':
          updateToolTip(false)
          history.push(dashboardContent + '/medieval-map-demo')
          break
        default:
          break
        // skip default case
      }
    } else {
      logoutSession(true)
    }
  }
  const ToggleMenuSetion = (isExpand) => {
    try {
      const classlist = document.getElementById('menuToggle').classList
      if (classlist && classlist.length > 0) {
        if (isExpand) {
          setShowTooltip(false)
          if (classlist.value.indexOf('resSidebar') > 0)
            document.getElementById('menuToggle').classList.remove('resSidebar')
        } else {
          if (classlist.value.indexOf('resSidebar') < 0) {
            setTimeout(function () { setShowTooltip(true) }, 2000)
            document.getElementById('menuToggle').classList.add('resSidebar')
          }

        }
      }
    } catch (e) { console.log(e) }
  }
  let pathname = window.location.pathname
  if (pathname) {
    pathname = pathname.replace('/', '')
  }

  return (
    <div ref={menuToggle} className="p-col-2 sidebar" id="menuToggle">
      <div className="sidebar--menuSec">
        <ul>
          <OverlayTrigger placement="right" overlay={dashboard} >
            <li onClick={() => navigatePage('dashboard')} className={pathname.indexOf('dashboard/dashboard') > -1 ? 'active' : ''}><span className="icon dashboardIcn" /> <span className="menuContent">Dashboard</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={preview}>
            <li onClick={() => navigatePage('preview')} className={pathname.indexOf('dashboard/preview') > -1 ? 'active' : ''}><span className="icon bubble" /> <span className="menuContent"> Preview</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={medievalMapDemo}>
            <li onClick={() => navigatePage('medieval_map_demo')} className={pathname.indexOf('dashboard/medieval-map-demo') > -1 ? 'active' : ''}><span className="icon mapkey" /> <span className="menuContent"> Medieval Map Demo</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={searchCompanies}>
            <li onClick={() => navigatePage('companies')} className={pathname.indexOf('dashboard/company-tree') > -1 ? 'active' : ''}><span className="icon search" /> <span className="menuContent"> Search Companies</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageSectors}>
            <li onClick={() => navigatePage('sector')} className={pathname.indexOf('sector-list') > -1 ? 'active' : ''}><span className="icon category" /> <span className="menuContent">Manage Sectors</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageIndustries}>
            <li onClick={() => navigatePage('industry')} className={pathname.indexOf('industry-list') > -1 ? 'active' : ''}><span className="icon industry" /> <span className="menuContent">Manage Industries</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageCompanies}>
            <li onClick={() => navigatePage('company')} className={pathname.indexOf('company-list') > -1 ? 'active' : ''}><span className="icon company" /> <span className="menuContent">Manage Companies</span> </li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={copyPaste}>
            <li onClick={() => navigatePage('import')} className={pathname.indexOf('import-data') > -1 ? 'active' : ''}><span className="icon copyPaste" /> <span className="menuContent">Copy & Paste Data</span> </li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageExchanges}>
            <li onClick={() => navigatePage('exchange')} className={pathname.indexOf('exchange-list') > -1 ? 'active' : ''}><span className="icon exchange" /> <span className="menuContent">Manage Exchanges</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={mapKeys}>
            <li onClick={() => navigatePage('mapkey')} className={pathname.indexOf('map-keys') > -1 ? 'active' : ''}><span className="icon map" /> <span className="menuContent">Map Keys</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={settings}>
            <li onClick={() => navigatePage('settings')} className={pathname.indexOf('settings') > -1 ? 'active' : ''}><span className="icon gear" /> <span className="menuContent">Settings</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageUsers}>
            <li onClick={() => navigatePage('user')} className={pathname.indexOf('user-list') > -1 ? 'active' : ''}><span className="icon user" /> <span className="menuContent">Manage Users</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={bulkUpload}>
            <li onClick={() => navigatePage('bulk_upload')} className={pathname.indexOf('bulk-upload') > -1 ? 'active' : ''}><span className="icon upload" /> <span className="menuContent">Bulk Upload - Data</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={manageContent}>
            <li onClick={() => navigatePage('content')} className={pathname.indexOf('content-list') > -1 ? 'active' : ''}><span className="icon font" /> <span className="menuContent">Manage Content</span></li>
          </OverlayTrigger>
          <OverlayTrigger placement="right" overlay={library}>
            <li onClick={() => navigatePage('library')} className={pathname.indexOf('library') > -1 ? 'active' : ''}><span className="icon book" /> <span className="menuContent">Library</span></li>
          </OverlayTrigger>

        </ul>
      </div>
    </div>
  )
}
SidebarComponent.propTypes = {
  updateToolTip: PropTypes.func,
  isExpand: PropTypes.bool,
}
export default SidebarComponent
